export default "__VITE_PUBLIC_ASSET__60d0e73c__"